module.exports = __webpack_public_path__ + "img/generated-substation.63d7a3a5.png";